"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateWorkflowData = exports.generateExampleActivity = exports.generateComplexQuestionnaire = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const types_1 = require("../types");
const others_1 = require("./../types/others");
const generateComplexQuestionnaire = (listId) => {
    return {
        questions: [
            {
                type: types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE,
                answer_text: "",
                tag: "gender",
                question_text: "What is your gender?",
                description: ".",
                required: false,
                options: [
                    {
                        key: "m",
                        value: "Man",
                    },
                    {
                        key: "w",
                        value: "Woman",
                    },
                    {
                        key: "u",
                        value: "Undefined",
                    },
                ],
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 0,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.TEXT,
                answer_text: "",
                tag: "name",
                question_text: "What is your name?",
                description: ".",
                default_value: "Jacky Chan",
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 1,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.PICTURE,
                answer_text: "",
                tag: "selfy",
                question_text: "Take a picture of yourself",
                description: "Please smile!",
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 2,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.DECIMAL,
                answer_text: "",
                tag: "age",
                question_text: "How old are you?",
                description: "description",
                required: false,
                number_of_options: -1,
                column_type: "float",
                index: 3,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE,
                answer_text: "",
                tag: "glasses",
                question_text: "You are old!! Do you wear glasses?",
                description: ".",
                conditions: [],
                required: false,
                options: [
                    {
                        key: "yes",
                        value: "Yes",
                    },
                    {
                        key: "no",
                        value: "No",
                    },
                ],
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 4,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.BARCODE_SCANNER,
                answer_text: "",
                tag: "barcode",
                question_text: "Question for barcode",
                description: "description",
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 5,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE,
                answer_text: "",
                tag: "pet",
                question_text: "What pet do you own?",
                description: "You can choose many option",
                required: false,
                options: [
                    {
                        key: "c",
                        value: "Cat",
                    },
                    {
                        key: "d",
                        value: "Dog",
                    },
                    {
                        key: "m",
                        value: "Mouse",
                    },
                    {
                        key: "r",
                        value: "Rabbit",
                    },
                    {
                        key: "s",
                        value: "Snake",
                    },
                ],
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 6,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE,
                answer_text: "",
                tag: "snake",
                question_text: "Did you know having a snake at home can be dangerous?",
                description: ".",
                conditions: [],
                required: false,
                options: [
                    {
                        key: "y",
                        value: "Yes",
                    },
                    {
                        key: "n",
                        value: "No",
                    },
                    {
                        key: "p",
                        value: "Pfff it's FINE!",
                    },
                ],
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 7,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE,
                answer_text: "",
                tag: "nationality",
                question_text: "What nationality(ies) do you have?",
                description: "You can choose many options",
                required: false,
                options: [
                    {
                        key: "fr",
                        value: "French",
                    },
                    {
                        key: "ke",
                        value: "Kenyan",
                    },
                    {
                        key: "ge",
                        value: "German",
                    },
                    {
                        key: "en",
                        value: "English",
                    },
                ],
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 8,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.TEXT,
                answer_text: "",
                tag: "tribe",
                question_text: "What is your tribe?",
                description: "Ex: Kikuyu, Lou, Kalenji...",
                conditions: [],
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 9,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.MATRIX_ON_LIST,
                answer_text: "",
                tag: "customersmatrix",
                question_text: "Tell me more about your customers",
                description: "",
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                list_id: listId,
                matrix: {
                    typed_questions: [
                        {
                            type: types_1.CUSTOM_FIELD_TYPE.TEXT,
                            answer_text: "",
                            tag: "feeling",
                            question_text: "What is you feeling about this customer?",
                            description: ".",
                            required: false,
                            number_of_options: -1,
                            column_type: others_1.COLUMN_TYPE.STRING,
                            index: 0,
                        },
                        {
                            type: types_1.CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_INTEGER,
                            answer_text: "",
                            tag: "multipleinputintegerinmatrix",
                            question_text: "Multiple Input Integer question",
                            required: false,
                            column_type: others_1.COLUMN_TYPE.INTEGER,
                            index: 1,
                        },
                        {
                            type: types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE,
                            answer_text: "",
                            tag: "customernationnalities",
                            question_text: "What is his nationnalities?",
                            options: [
                                {
                                    key: "fr",
                                    value: "French",
                                },
                                {
                                    key: "en",
                                    value: "English",
                                },
                            ],
                            required: false,
                            column_type: others_1.COLUMN_TYPE.INTEGER,
                            index: 1,
                        },
                    ],
                },
                index: 10,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST,
                answer_text: "",
                tag: "best_customer",
                question_text: "What is your favourite customer?",
                description: "",
                required: false,
                list_id: listId,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 11,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST,
                answer_text: "",
                tag: "worst_customer",
                question_text: "What is your less liked customer?",
                description: "",
                required: false,
                list_id: listId,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 12,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST,
                answer_text: "",
                tag: "customers",
                question_text: "Which customers have you talked to for the last week?",
                description: "Select one or several",
                required: false,
                list_id: listId,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 13,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.INTEGER,
                answer_text: "",
                tag: "rate",
                question_text: "Rate Smala Application",
                description: "Between 0 and 10",
                default_value: "10",
                required: true,
                validation: "^(10|[0-9])$",
                validation_text: "please enter a number between 0 and 10",
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.INTEGER,
                index: 14,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.SIGNATURE,
                answer_text: "",
                tag: "signature",
                question_text: "Ask for the owner's shop signature",
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 15,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.PLAIN_TEXT,
                answer_text: "",
                tag: "plain",
                question_text: "Hey there! This is juste an information!",
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 16,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.GPS,
                answer_text: "",
                tag: "location",
                question_text: "Question for location",
                description: "description for location",
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 17,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.GPS,
                answer_text: "",
                tag: "home_location",
                question_text: "Question for location",
                description: "description for location",
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 18,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.TIME_PICKER,
                answer_text: "",
                tag: "time",
                question_text: "At what time did you arrive?",
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 19,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.DATE_PICKER,
                answer_text: "",
                tag: "date",
                question_text: "When was the incident?",
                required: false,
                number_of_options: -1,
                column_type: others_1.COLUMN_TYPE.STRING,
                index: 20,
            },
            {
                type: types_1.CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_INTEGER,
                answer_text: "",
                tag: "multipleinputinteger",
                question_text: "Multiple Input Integer question",
                required: false,
                column_type: others_1.COLUMN_TYPE.INTEGER,
                index: 21,
            },
        ],
    };
};
exports.generateComplexQuestionnaire = generateComplexQuestionnaire;
const generateExampleActivity = (activityId, customersListId) => {
    return {
        id: activityId,
        report_title_template: "report name",
        name: "activity name",
        active: true,
        report_prerequisite: types_1.REPORT_PREREQUISITE.NO_NEED,
        updated_at: new Date(),
        updated_by: "",
        version: 0,
        questionnaire: (0, exports.generateComplexQuestionnaire)(customersListId),
    };
};
exports.generateExampleActivity = generateExampleActivity;
const generateWorkflowData = (workflow = {}) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return {
        id: (_a = workflow.id) !== null && _a !== void 0 ? _a : (0, tools_1.IDSource)(),
        name: (_b = workflow.name) !== null && _b !== void 0 ? _b : en_1.faker.word.words(4),
        picture_url: (_c = workflow.picture_url) !== null && _c !== void 0 ? _c : "picture_url",
        attached_lists: (_d = workflow.attached_lists) !== null && _d !== void 0 ? _d : [],
        unique_usage: (_e = workflow.unique_usage) !== null && _e !== void 0 ? _e : false,
        version: (_f = workflow.version) !== null && _f !== void 0 ? _f : 0,
        active: (_g = workflow.active) !== null && _g !== void 0 ? _g : true,
        starting_step_id: (_h = workflow.starting_step_id) !== null && _h !== void 0 ? _h : "step0",
        first_step_params: (_j = workflow.first_step_params) !== null && _j !== void 0 ? _j : [],
        steps: (_k = workflow.steps) !== null && _k !== void 0 ? _k : [
            {
                id: "step0",
                type: types_1.STEP_TYPE.ACTIVITY,
                schema_id: "vendorBooking",
                is_editable: true,
                scope: types_1.STEP_SCOPE.GLOBAL,
            },
            {
                id: "step1",
                type: types_1.STEP_TYPE.ACTIVITY,
                schema_id: "vendorReturn",
                is_editable: true,
                scope: types_1.STEP_SCOPE.GLOBAL,
            },
        ],
        chainings: (_l = workflow.chainings) !== null && _l !== void 0 ? _l : [
            {
                id: "chaining0",
                origin_step: "step0",
                destination_step: "step1",
                destination_params: [],
                conditions: [],
            },
        ],
        created_by: (_m = workflow.created_by) !== null && _m !== void 0 ? _m : "admin@optimetriks.com",
        created_at: (_o = workflow.created_at) !== null && _o !== void 0 ? _o : new Date(),
        updated_by: (_p = workflow.updated_by) !== null && _p !== void 0 ? _p : "admin@optimetriks.com",
        updated_at: (_q = workflow.updated_at) !== null && _q !== void 0 ? _q : new Date(),
    };
};
exports.generateWorkflowData = generateWorkflowData;
